const DEFAULT_APP_CONFIG = Object.freeze({
  forceLive: false,
  allowResearcher: false,
  telemetryEndpoint: '/api/telemetry',
  telemetryToken: null,
  appVersion: 'unknown',
  devBackendUrl: 'http://127.0.0.1:8787',
});

function injectedConfig() {
  try {
    return import.meta.env?.PRIVACY_METER_CONFIG ?? {};
  } catch {
    return {};
  }
}

export function normalizeAppConfig(config = {}) {
  if (!config || typeof config !== 'object' || Array.isArray(config)) {
    return { ...DEFAULT_APP_CONFIG };
  }
  return {
    ...DEFAULT_APP_CONFIG,
    ...config,
  };
}

export const appConfig = Object.freeze(normalizeAppConfig(injectedConfig()));
